import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    brandBlue: 'rgb(49, 110, 177)',
    brandTeal: 'rgb(78, 158, 163)',
    primary: '#2E8CAB',
    highlightPrimary: '#2E8CAB90',
    secondary: '#F0F4FF',
    background: '#f8fafc',
    contentBackground: '#212937',
    lightBackground: '#f9fbfc',
    text: '#1F2937',
    white: '#FFFFFF',
    dimGreen: '#08c6ab',
  },
  tabletWidth: '992px',
  phoneWidth: '768px',
  font: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  fontSizes: { xxs: '0.75rem', xs: '0.875rem', s: '1rem', md: '1.125rem', lg: '1.25rem', xl: '2rem', xxl: '2.5rem' },
  spacing: (n) => `${n * 8}px`,
};

export const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box; }
  body {
    margin: 0;
    font-family: ${props => props.theme.font};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }
`;
